import {
  FETCH_ALL_LINKED_CATEGORIES,
  ADD_LINKED_CATEGORIES_SET,
  LinkedCategory,
  RESET_UPLOAD_SUCCESS,
  FETCH_LINKED_CATEGORY_SET_BY_CATEGORY,
  RESET_LINKED_CATEGORY_DATA,
} from "./LinkedCategoriesTypes";

export interface LinkedCategoriesState {
  loading: boolean;
  data: LinkedCategory[];
  uploadProgress: boolean;
  isUploadSuccess: boolean;
  linkedCategorySetByCategory: LinkedCategory;
}

const initialState: LinkedCategoriesState = {
  loading: false,
  data: [],
  uploadProgress: false,
  isUploadSuccess: false,
  linkedCategorySetByCategory: {
    linkedCategorySetId: "",
    categories: [],
  },
};

export const LinkedCategoriesReducer = (
  state: LinkedCategoriesState = initialState,
  action: any,
): LinkedCategoriesState => {
  switch (action.type) {
    case FETCH_ALL_LINKED_CATEGORIES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_LINKED_CATEGORIES.SUCCESS:
      const { results } = action.payload;
      return {
        ...state,
        loading: false,
        data: results,
      };
    case FETCH_ALL_LINKED_CATEGORIES.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ADD_LINKED_CATEGORIES_SET.REQUEST:
      return {
        ...state,
        uploadProgress: true,
        isUploadSuccess: false,
      };
    case ADD_LINKED_CATEGORIES_SET.SUCCESS:
      return {
        ...state,
        uploadProgress: false,
        isUploadSuccess: true,
      };
    case ADD_LINKED_CATEGORIES_SET.FAILURE:
      return {
        ...state,
        uploadProgress: false,
      };
    case RESET_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadProgress: false,
        isUploadSuccess: false,
      };
    case FETCH_LINKED_CATEGORY_SET_BY_CATEGORY.REQUEST:
      return {
        ...state,
        linkedCategorySetByCategory: {
          linkedCategorySetId: "",
          categories: [],
        },
      };
    case FETCH_LINKED_CATEGORY_SET_BY_CATEGORY.SUCCESS:
      return {
        ...state,
        linkedCategorySetByCategory: action.payload,
      };
    case FETCH_LINKED_CATEGORY_SET_BY_CATEGORY.FAILURE:
      return {
        ...state,
        linkedCategorySetByCategory: {
          linkedCategorySetId: "",
          categories: [],
        },
      };
    case RESET_LINKED_CATEGORY_DATA:
      return {
        ...state,
        data: [],
        linkedCategorySetByCategory: {
          linkedCategorySetId: "",
          categories: [],
        },
      };
    default:
      return state;
  }
};
